import React, {useEffect, useState} from "react";
import SearchTable from "../../../primer/Search-Table";
import {useDispatch, useSelector} from "react-redux";
import {getOptionsByData, quotationsStatusOptions} from '../../../../_helpers/commonFunctions';
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {fetchAdvancedTypes} from "../../../../_apis/api";
import {useTranslation} from "../../../../hooks/useTranslation";

const QuotationsSearch = () => {
    const {t} = useTranslation();
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const quotationsDT = getObjectFromArrayOfObjects(allDocumentTypes,  "Quotations",  "section");
    const documentTypesOptions = getOptionsByData(quotationsDT, "_id", "name");
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}))
    }, []);

    const qqColumns = [
        {
            name: t('SalesSearch.table.date'),
            field: "date",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.client'),
            field: "clientName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.documentType'),
            field: "documentTypeName",
            width: "300px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.number'),
            field: "number",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.totalNetValue'),
            field: "totalNetValue",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t('SalesSearch.table.totalVatValue'),
            field: "totalVatValue",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t('SalesSearch.table.totalSum'),
            field: "totalAmount",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: "Κατάσταση",
            field: "status",
            width: "150px",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Σημειώσεις",
            field: "notes",
            width: "100px",
            hiddenColumn: true,
            editable: false,
            inputType: {
                type: 'text',
            },
        }
    ]

    const searchQuotationFilters = {
        filters: [
            {
                name: "clientName",
                label: t('SalesSearch.table2.clientNameFrom'),
                type: "input",
            },
            {
                name: "productName",
                label: t('SalesSearch.table2.productName'),
                type: "input",
            },
            {
                name: "documentType",
                label: t('SalesSearch.table2.documentType'),
                type: "multiselect",
                options: documentTypesOptions
            },
            {
                name: "totalSum_from",
                label: t('SalesSearch.table2.totalSumFrom'),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "totalSum_to",
                label: t('SalesSearch.table2.totalSumTo'),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_from",
                label: t('SalesSearch.table2.preNumberFrom'),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_to",
                label: t('SalesSearch.table2.preNumberTo'),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "number_from",
                label: t('SalesSearch.table2.numberFrom'),
                type: "number",
                mdWidth: 2,
            },
            {
                name: "number_to",
                label: t('SalesSearch.table2.numberTo'),
                type: "number",
                mdWidth: 2,
            },
            {
                name: "notes",
                label: t('SalesSearch.table2.notes'),
                type: "input",
            },
            {
                name: "status",
                label: "Κατάσταση",
                type: "dropdown",
                options: quotationsStatusOptions(),
            },
        ]
    };

    const [tableColumns, setTableColumns] = useState(qqColumns.slice());

    // It will hide or show the table columns for searchtable.
    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <SearchTable
            tableName="Quotations Search"
            key={"Quotations Search"}
            hideYearFilter={false}
            allowPagination={true}
            allowToggleColumns={true}
            toggleColumns={handleColumnShowHide}
            allowPrintResults={true}
            dataEndpoint={"/sale/quotations-search-data"}
            exportFileName={"Προσφορές"}
            columns={tableColumns}
            data={[]}
            filtersConfig={searchQuotationFilters}
        />
    )
}

export default QuotationsSearch;